<template>
    <div id="login-form">
        <b-field :label="__('strings.auth.labels.email')"
                 label-position="on-border"
                 :type="{'is-danger': errors.email}"
                 :message="errors.email">
            <b-input :placeholder="__('strings.auth.labels.email')"
                     type="email" name="email"
                     icon="account" v-model="input.email" @focus="clearError">
            </b-input>
        </b-field>

        <b-field :label="__('strings.auth.labels.password')"
                 label-position="on-border"
                 :type="{'is-danger': errors.password}"
                 :message="errors.password">
            <b-input :placeholder="__('strings.auth.labels.password')"
                     type="password" name="password"
                     icon="key" v-model="input.password" @focus="clearError">
            </b-input>
        </b-field>

        <div class="field">
            <b-switch name="remember" v-model="input.remember">{{ __('strings.auth.labels.remember') }}</b-switch>
        </div>

        <div class="field">
            <b-button tag="button"
                      type="is-primary"
                      class="is-uppercase"
                      :label="__('strings.auth.login.button')"
                      rounded
                      outlined
                      expanded @click.prevent="login"></b-button>
        </div>

        <div class="field has-text-centered">
            <router-link :to="{name: 'auth.reset-password'}">{{ __('strings.auth.labels.forgot') }}</router-link>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                input: {
                    email: '',
                    password: '',
                    remember: false
                },
                errors: {
                    password: '',
                    email: ''
                }
            }
        },
        methods: {
            login() {
                axios.get(this.appinfo('api.domain') + '/sanctum/csrf-cookie')
                    .then(response => {
                        axios.post('/login', this.input)
                            .then(response => {
                                this.$router.push({name: 'home'})
                            })
                            .catch(error => {
                                this.errors = error.response.data.errors
                            })
                    })
                .catch(response => {
                    // todo manage error response
                })
            },
            clearError(event) {
                this.errors[event.target.name] = '';
            }
        }
    }
</script>